import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';

import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector, XYZ } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { MapService } from 'src/app/Service/map.service';

import { OtherService } from 'src/app/Service/other.service';

import axios from "src/app/Service/axios";

declare let $: any;

@Component({

  selector: 'custom-map',

  templateUrl: './custom-map.component.html',

  styleUrls: ['./custom-map.component.css']

})

export class CustomMapComponent implements OnInit {

  @Input() str_Placeholder: string = ""; //? تکست باکس - اختیاری 'placeholder' 

  @Input() stylesArray!: any[]; //? تکست باکس - اختیاری 'style' 

  @Input() strValue!: string; //? مقدار اولیه تکست باکس - اختیاری

  @Input() isDisabled: boolean = false; //? غیرفعال بودن تکست باکس - اختیاری

  @Input() longLat: number[] = [51.3833554, 35.6770113]; //? موقعیت پیش فرض نقشه

  @Input() isTextArea: boolean = true; //? انتخاب حالت دریافت آدرس

  @Input() isLocationBtn: boolean = true; //? انتخاب حالت نمایش دکمه نقشه

  @Input() isOpenModal: boolean = false; //? نمایش نقشه در ابتدا

  @Input() isView: boolean = false; //? فقط جهت نمایش موقعیت

  @Input() skip_Search: boolean = false; //?  skip searching by address

  @Output() mdl_Submit = new EventEmitter(); //? بستن نقشه بعد از کلیک بر روی آیتم

  map: any;

  vector: any;

  source: any;

  layers: any = [];

  bShowModal: boolean = false;

  private bOfflineMap: boolean = (<any>window).bOfflineMap;

  private strMapUrl: string = (<any>window).strMapUrl;

  mdl_Map: FormGroup = this._fb.group({

    strText: new FormControl(''),

    strText_Toolbar: new FormControl(''),

    strAddress: new FormControl(''),

    strCity: new FormControl(''),

    strState: new FormControl(''),

    isChanged: new FormControl(false),

    latitude: new FormControl(0),

    longitude: new FormControl(0)

  })

  constructor(

    private mapService: MapService,

    private _fb: FormBuilder,

    private _other: OtherService


  ) { }

  ngOnInit(): void {

    if (this.longLat[0] == 0 || this.longLat[1] == 0) {

      this.longLat = [51.3833554, 35.6770113]

    }

    if (this.strValue && this.strValue != '') {

      this.mdl_Map.controls['strText'].setValue(this.strValue);

      this.mdl_Map.controls['strText_Toolbar'].setValue(this.strValue);

    }

    if (this.isOpenModal) {

      if (this.strValue != '') {

        this.mdl_Map.controls['isChanged'].setValue(true);

        this.openMap();

      }

      else {

        this.openMap();

      }

    }

    if (this.isDisabled || !this.isLocationBtn) {

      this.mdl_Map.controls['strText'].disable()

    }

    if (this.isView) {

      this.mdl_Map.get('strText_Toolbar')?.disable()

    }


  }

  onInput() {

    this.mdl_Map.controls['isChanged'].setValue(true);

    // اگر کاربر متنی را به آدرس اضافه کرد

    this.mdl_Submit.emit(this.mdl_Map.value)

  }

  async openMap() {

    // this.bShowModal = false;

    // اگر کاربر چیزی را تایپ کرده بود

    if (this.mdl_Map.get('isChanged')?.value && !this.skip_Search) {

      this._other.Showspinner();

      let res = (await axios.post(`Geocoding`, { 'strAddress': this.mdl_Map.get('strText')?.value })).data;

      this._other.nonespinner();

      this.mdl_Map.controls['isChanged'].setValue(false);

      this.longLat = [res.fLon, res.fLat];

      this.mdl_Map.controls['strText_Toolbar'].setValue(res.strAddress);

      this.mdl_Map.controls['strText'].setValue(res.strAddress);

      this.mdl_Map.controls['strAddress'].setValue(res.strAddress);

      this.mdl_Map.controls['strCity'].setValue(res.strCity);

      this.mdl_Map.controls['strState'].setValue(res.strState);

      this.mdl_Map.controls['latitude'].setValue(res.fLat);

      this.mdl_Map.controls['longitude'].setValue(res.fLon);

      this.newOpenMap();

    }

    // اگر کاربر چیزی را تایپ نکرده بود

    else {

      this.newOpenMap();

    }

  }

  newOpenMap_2() {

    $('#map_Modal').modal('show');

    setTimeout(() => {

      if (this.map) this.map.setTarget(null);

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      const styles = [

        'AerialWithLabelsOnDemand',

      ];

      var iconStyle = new Style({

        image: new Icon(({

          anchor: [0, 46],

          anchorXUnits: 'fraction',

          anchorYUnits: 'pixels',

          size: [48, 48],

          opacity: 1,

          src: '../../assets/Img/marker4.png'

        }))

      });

      let i, ii; 

      for (i = 0, ii = styles.length; i < ii; ++i) {

        this.layers.push(

          new TileLayer({

            visible: false,

            preload: Infinity,

            source: new BingMaps({

              // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                            key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


              imagerySet: styles[i],

            }),

          }),

        );
      }

      this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)

      this.map = new Map({

        layers: this.layers,

        target: 'map_Container',

        view: new View({

          center: olProj.fromLonLat(this.longLat),

          zoom: 17,

        }),

      });

      const marker = new Feature({

        geometry: new Point(olProj.fromLonLat(this.longLat)),

      });

      const vectorLayer = new VectorLayer({

        source: new VectorSource({

          features: [marker],

        }),

        style: new Style({

          image: new Icon({

            src: '../../assets/Img/marker4.png',

            scale: 1.0,

          }),

        }),

      });

      this.map.addLayer(vectorLayer);

      this.map.on('click', (e: any) => {

        if (this.isView) return;

        this.map.removeLayer(vectorLayer)

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        this.mdl_Map.controls['latitude'].setValue(coords[1]);

        this.mdl_Map.controls['longitude'].setValue(coords[0]);

        this.submitAddress(true)

        var iconGeometry = new Point(e.coordinate)

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map.getLayers().forEach((layer: VectorSource) => {

          let layers = this.map.getLayers().getArray();

          for (const item of layers) {

            if (item.getKeys().length < 11) {

              this.map.removeLayer(item);

            }

          }

        });

        this.map.addLayer(dinamicPinLayer);

        var view = this.map.getView();

        view.animate({

          center: olProj.transform(

            [coords[0], coords[1]],

            'EPSG:4326',

            'EPSG:3857'
          ),

          duration: 1000,

        });

      })

    }, 500);

  }

  newOpenMap() {

    $('#map_Modal').modal('show');

    setTimeout(() => {

      if (this.map) {

        this.map.setTarget(null); // پاک کردن target از نقشه قبلی

        this.map = undefined; // تنظیم مجدد نقشه

        this.layers = []; // پاک کردن لایه های قبلی

      }

      this.source = new VectorSource({ wrapX: false });

      this.vector = new VectorLayer({

        source: this.source,

      });

      const iconStyle = new Style({
        image: new Icon({
          anchor: [0, 46],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          size: [48, 48],
          opacity: 1,
          src: '../../assets/Img/marker4.png'
        })
      });

      if (this.bOfflineMap) {

        this.layers.push(

          new TileLayer({

            source: new XYZ({

              // url: 'http://your-local-server/tiles/{z}/{x}/{y}.png',

              url: this.strMapUrl,

              attributions: 'Map data © RayanAndishehNasr' // 

            }),

          })

        );

      }

      else {

        const styles = [

          'AerialWithLabelsOnDemand',

        ];

        let i, ii;

        for (i = 0, ii = styles.length; i < ii; ++i) {

          this.layers.push(

            new TileLayer({

              visible: false,

              preload: Infinity,

              source: new BingMaps({

                // key: 'AkUPx3euT5YcJeljnCtLb7aEpgoCLc9hMqiQj291YVL_4pSJJtVSjHFnDlDdJELM',
                              key: 'Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j',


                imagerySet: styles[i],

              }),

            }),

          );
        }

        this.layers.push(new TileLayer({ source: new OSM({}), }), this.vector)


      }

      // this.layers.push(this.vector);

      this.map = new Map({

        layers: this.layers,

        target: 'map_Container',

        view: new View({

          center: olProj.fromLonLat(this.longLat),

          zoom: 17,

        }),

      });

      const marker = new Feature({

        geometry: new Point(olProj.fromLonLat(this.longLat)),

      });

      const vectorLayer = new VectorLayer({

        source: new VectorSource({

          features: [marker],

        }),

        style: new Style({

          image: new Icon({

            src: '../../assets/Img/marker4.png',

            scale: 1.0,

          }),

        }),

      });

      this.map.addLayer(vectorLayer);

      this.map.on('click', (e: any) => {

        if (this.isView) return;

        this.map.removeLayer(vectorLayer)

        if (e.dragging) return;

        var coords = olProj.toLonLat(e.coordinate);

        this.mdl_Map.controls['latitude'].setValue(coords[1]);

        this.mdl_Map.controls['longitude'].setValue(coords[0]);

        this.submitAddress(true)

        var iconGeometry = new Point(e.coordinate)

        var iconFeature = new Feature({

          geometry: iconGeometry,

        });

        iconFeature.setStyle(iconStyle);

        var vectorSource = new Vector({

          features: [iconFeature]

        });

        var dinamicPinLayer = new VectorLayer({

          source: vectorSource

        });

        this.map?.getLayers().forEach((layer: any) => {

          if (layer.getSource() instanceof VectorSource && layer !== vectorLayer) {

            const features = layer.getSource().getFeatures();

            if (features.length === 1 && features[0].getGeometry() instanceof Point) {

              this.map?.removeLayer(layer);

            }

          }

        });


        this.map?.addLayer(dinamicPinLayer);

        var view = this.map.getView();

        view.animate({

          center: olProj.transform(

            [coords[0], coords[1]],

            'EPSG:4326',

            'EPSG:3857'
          ),

          duration: 1000,

        });

      })

    }, 500);

  }

  async submitAddress(isClicked: boolean = false) {

    if (isClicked) {

      this._other.Showspinner();

      let model = {

        fLat: this.mdl_Map.controls['latitude'].value,

        fLon: this.mdl_Map.controls['longitude'].value,

      }

      const address = await axios.post(`ReverseGeocoding`, this._other.stringNumberToNumber(model));

      this._other.nonespinner();

      this.mdl_Map.get('strText_Toolbar')?.setValue(address.data.strAddress);

    }

    else {

      this.longLat = [this.mdl_Map.get('longitude')?.value, this.mdl_Map.get('latitude')?.value];

      this.mdl_Map.get('strText')?.setValue(this.mdl_Map.get('strText_Toolbar')?.value);

      this.mdl_Map.get('strAddress')?.setValue(this.mdl_Map.get('strText_Toolbar')?.value);

      this.mdl_Submit.emit(this.mdl_Map.value);

      $('#map_Modal').modal('hide');


    }

  }

  async getLatLong() {

    this._other.Showspinner();

    let res = (await axios.post(`Geocoding`, { 'strAddress': this.mdl_Map.get('strText_Toolbar')?.value })).data;

    this._other.nonespinner();

    this.mdl_Map.get('longitude')?.setValue(res.fLon);

    this.mdl_Map.get('latitude')?.setValue(res.fLat);

    this.mdl_Map.get('strText_Toolbar')?.setValue(res.strAddress);

    // پاک کردن موقعیت قبلی از روی نقشه

    this.map.getLayers().forEach((layer: VectorSource) => {

      let layers = this.map.getLayers().getArray();

      for (const item of layers) {

        if (item.getKeys().length < 11) {

          this.map.removeLayer(item);

        }

      }

    });

    // ترسیم موقعیت جدید روی نقشه

    const marker = new Feature({

      geometry: new Point(olProj.fromLonLat([res.fLon, res.fLat])),

    });

    const vectorLayer = new VectorLayer({

      source: new VectorSource({

        features: [marker],

      }),

      style: new Style({

        image: new Icon({

          src: '../../assets/Img/marker4.png',

          scale: 1.0,

        }),

      }),

    });

    this.map.addLayer(vectorLayer);

    // زوم روی ناحیه دریافت شده

    var view = this.map.getView();

    view.animate({

      center: olProj.transform(

        [res.fLon, res.fLat],

        'EPSG:4326',

        'EPSG:3857'
      ),

      duration: 1000,

    });

  }

  getStylesObject(): { [key: string]: string } {

    if (!this.stylesArray) return {};

    let styles: { [key: string]: string } = {};

    this.stylesArray.forEach(styleString => {

      const [property, value] = styleString.split(':').map((s: any) => s.trim());

      styles[property] = value;

    });

    return styles;

  }

}
